import { InjectionToken, Signal } from '@angular/core';
import { Operations } from '@it2go/types';
import { LoggedUserGlobalStoreType } from './logged-user.global-store.type';

export const GLOBAL_STORE_TOKEN = new InjectionToken<GlobalStoreType>('GlobalStoreType');

export interface GlobalStoreType {

    loggedUserStore: LoggedUserGlobalStoreType;

    isAllowedForService(operation: Operations | string, serviceId: number): Signal<boolean>;

}
